import { render, staticRenderFns } from "./Coupon.vue?vue&type=template&id=659ce657&scoped=true"
import script from "./Coupon.vue?vue&type=script&lang=js"
export * from "./Coupon.vue?vue&type=script&lang=js"
import style0 from "./Coupon.vue?vue&type=style&index=0&id=659ce657&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659ce657",
  null
  
)

export default component.exports